import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import OnBeforePaymentCreate from '../../_common/onBeforePaymentCreate.mdx';
import OnCheckoutComplete from '../../_common/onCheckoutComplete.mdx';
import ClientSessionLifecycleCallbacks from '../../_common/clientSessionLifecycleCallbacks.mdx';
import ManualPaymentHandling from '../../_common/manualPaymentHandling.mdx';
import ClientSessionCachingEnabled from '../../_common/clientSessionCachingEnabled.mdx';
import OnCheckoutFail from '../../primer-headless-checkout/_configure/onCheckoutFail.mdx';
import ConfigurePaymentMethodType from '../../primer-headless-checkout/_configure/paymentMethodType.mdx';
import HeadlessPaymentMethodsOptions from '../../_common/headlessPaymentMethodsOptions.mdx';
import OnPaymentMethodAction from '../../_common/onPaymentMethodAction.mdx';
import ApiVersion from '../../_common/apiVersion.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='options' subtitle='object' mdxType="Item">
	Options for a Headless Universal Checkout, its properties can be defined to configure the checkout experience.
	<Group mdxType="Group">
		<Item title='onAvailablePaymentMethodsLoad' subtitle='(paymentMethods: PaymentMethodInfo[]) => void' label='Required' mdxType="Item">
			Called when the available payment methods have been loaded. Takes an array of objects as its argument.
			<Group summary='Parameters' mdxType="Group">
				<Item title='paymentMethods' subtitle='PaymentMethodInfo[]' mdxType="Item">
					<Group summary='Properties' mdxType="Group">
						<Item title='type' subtitle='PaymentMethodType' label='Required' mdxType="Item">
							<ConfigurePaymentMethodType mdxType="ConfigurePaymentMethodType" />
						</Item>
						<Item title='managerType' subtitle='"CARD" | "NATIVE" | "REDIRECT"' label='Required' mdxType="Item">
							The type of payment manager to use.
						</Item>
					</Group>
				</Item>
			</Group>
		</Item>
		<Item title='locale' subtitle='string' mdxType="Item">
			This option forces the locale for certain UI elements. By default, the locale will be set to the browser's locale.
		</Item>
		<ApiVersion mdxType="ApiVersion" />
	</Group>
	<Group open summary='Payment lifecycle callbacks' mdxType="Group">
		<Item title='onPaymentCreationStart' subtitle='() => void' mdxType="Item">
			Notifies you before the checkout tokenizes a payment method and creates a payment.
		</Item>
		<Item title='onBeforePaymentCreate' subtitle='(data: object, handler: object) => void' mdxType="Item">
			<OnBeforePaymentCreate mdxType="OnBeforePaymentCreate" />
		</Item>
		<Item title='onCheckoutComplete' subtitle='(data: object) => void' mdxType="Item">
			<OnCheckoutComplete mdxType="OnCheckoutComplete" />
		</Item>
		<Item title='onCheckoutFail' subtitle='(error: PrimerClientError, data: object, handler: object) => void' mdxType="Item">
			<OnCheckoutFail mdxType="OnCheckoutFail" />
		</Item>
	</Group>
  <Group summary='Event callbacks' mdxType="Group">
    <Item title='onPaymentMethodAction' subtitle='(action: string, data: object) => void' mdxType="Item">
      <OnPaymentMethodAction mdxType="OnPaymentMethodAction" />
    </Item>
  </Group>
	<Group summary='Payment methods options' mdxType="Group">
		<HeadlessPaymentMethodsOptions mdxType="HeadlessPaymentMethodsOptions" />
	</Group>
	<Group summary='Manual payment handling' mdxType="Group">
		<ManualPaymentHandling mdxType="ManualPaymentHandling" />
	</Group>
	<ClientSessionLifecycleCallbacks mdxType="ClientSessionLifecycleCallbacks" />
	<ClientSessionCachingEnabled mdxType="ClientSessionCachingEnabled" />
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      